import { media } from 'Config/styled'
import styled, { css } from 'styled-components'

export const Container = styled.div`
  height: calc(100vh - 225px);
  overflow-y: scroll;
  padding: 50px 30px;

  ${props =>
    props.$tutorial &&
    css`
      height: calc(100vh - 275px);
    `}

  ${media('lg')} {
    padding: 1rem;
  }
`

export const Separator = styled.div`
  padding-bottom: 30px;
`

export const FiltersMasterContainer = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex: 1;

  .separator {
    width: 16px;
  }
`

export const FiltersContainer = styled.div`
  width: 100%;
  margin-bottom: 32px;
  display: grid;
  grid-template-columns: 2fr 2fr;
  gap: 1rem;

  .separator {
    width: 16px;
  }

  ${media('lg')} {
    grid-template-columns: 1fr;
  }
`

export const FilterSelected = styled.div`
  display: inline-flex;
  flex-direction: row;
  padding: 0.5rem 1rem;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  background: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.white};
  border-radius: 10px;
  margin-right: 16px;

  .icon {
    fill: ${props => props.theme.colors.white};
    margin-left: 0.5rem;
  }
`
